import Config from "@/const/Config";
import { BaseApi } from "./BaseApi";

export class ConfigApi extends BaseApi {
  /**
   * 業務日時をサーバーから取得します
   * 通常はConfigストアのgetSysDatetimeを使用して下さい
   * @returns
   */
  public async getSystemDatetime(): Promise<Date> {
    try {
      const res = await this.get<GetSysDatetimeRes>(Config.API_URL + '/config/get_sys_datetime')
      return new Date(res.data.sys_datetime);
    } catch (e: unknown) {
      throw e
    }
  }

  public async setSystemDatetime(datetime: string): Promise<boolean> {
    try {
      const param = {
        sys_datetime: datetime
      }
      const res = await this.post<boolean>(Config.API_URL + '/config/set_sys_datetime', param)
      return res.data;
    } catch (e: unknown) {
      throw e
    }
  }

  /**
   * 打刻の丸め時間（分）をサーバーから取得します
   * 通常はgetDakokuRoundを使用して下さい
   * @returns
   */
  public async getDakokuRound(): Promise<number> {
    try {
      const res = await this.get<GetDakokuRoundRes>(Config.API_URL + '/config/get_dakoku_round')
      return parseInt(res.data.dakoku_round);
    } catch (e: unknown) {
      throw e
    }
  }
}

export interface GetSysDatetimeRes {
  sys_datetime: string
}

export interface GetDakokuRoundRes {
  dakoku_round: string
}
